import React from "react"
import snackBar from "src/utilities/snackBar/SnackBar"
import "./CameraNotFound.css"

function CameraNotFound() {

    snackBar({ text: "No camera found", type: "error", timeout: 3000 })

    return (
        <div className="CameraNotFound">
            <div className="CameraNotFoundInner">
                <span className="material-icons">photo_camera</span>
            </div>
            <div className="CameraNotFoundOuter">
                <span className="material-icons">do_not_disturb_alt</span>
            </div>
        </div>
    )
}

export default CameraNotFound